<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      <el-form :inline="true" class="backborder1 agent-area demo-form-inline" size="small">
	  	    <el-form-item style="width:32%" label="下单时间" label-width="120">
          	  <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
          <el-form-item label="实付金额区间" label-width="120" style="width:32%">
              <el-input type="text" clearable v-model="query.sprice" style="width:40%" @change="ischange=true"/>
              <div style="position:relative;display:inline-block;padding:0 6px">~</div>
              <el-input type="text" clearable v-model="query.eprice" style="width:40%" @change="ischange=true"/>
          </el-form-item>
          <el-form-item label="下单数量区间" label-width="120" style="width:32%">
              <el-input type="text" clearable v-model="query.snums" style="width:40%" @change="ischange=true"/>
              <div style="position:relative;display:inline-block;padding:0 6px">~</div>
              <el-input type="text" clearable v-model="query.enums" style="width:40%" @change="ischange=true"/>
          </el-form-item>
          <el-form-item label="店铺所在地" label-width="120" style="width:32%">
              <el-select v-model="query.provinceid" clearable remote  filterable placeholder="请选择省份" @change="changecity(query.provinceid)" style="width:40%">	            
                  <el-option v-for="(item,index) in provincelists" :label="item.showlable" :value="item.id" :key="index">
                  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                  <span style="float: left">{{item.name}}</span>
                  </el-option>              
              </el-select>
              <el-select v-model="query.cityid" clearable remote  filterable placeholder="请选择城市" @change="ischange=true" v-if="citylists.length > 0" style="width:40%;margin-left:5px">	            
                  <el-option v-for="(item,index) in citylists" :label="item.showlable" :value="item.id" :key="index">
                  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                  <span style="float: left">{{item.name}}</span>
                  </el-option>              
              </el-select> 
          </el-form-item>
		      <el-form-item label="店员标签" label-width="120" style="width:32%">
			        <el-select v-model="query.labelid" clearable remote  filterable placeholder="请选择店员标签" @change="ischange=true">
	          	    <el-option v-for="(item,index) in labellists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          </el-form-item>
		      <el-form-item label="关键字搜索类型" label-width="120" style="width:32%">
			        <el-select v-model="query.keytype" remote  filterable placeholder="请选择关键字类型" @change="ischange=true">
	          	    <el-option v-for="(item,index) in keylists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          </el-form-item>
		      <el-form-item label="关键字" label-width="120" style="width:32%" class="input1">
			        <el-input  placeholder="店员名称 / 手机号 / 店铺名称" type="text" clearable v-model="query.key" @change="ischange=true"/>
          </el-form-item>
		      <el-form-item label="排序类型" label-width="120" style="width:32%">
			        <el-select v-model="query.sorttype" remote  filterable placeholder="请选择排序类型" @change="ischange=true">
	          	    <el-option v-for="(item,index) in sorttype" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          </el-form-item>
		      <el-form-item label="排序方式" label-width="120" style="width:32%">
			        <el-select v-model="query.sort" remote  filterable placeholder="请选择排序方式" @change="ischange=true">
	          	    <el-option v-for="(item,index) in sortlists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select> 
          </el-form-item>
          <el-form-item style="width:100%">
              <el-button size="mini" type="primary" icon="el-icon-search" @keyup.enter.native="getList" @click="getList">搜索</el-button>
              <el-button size="mini" type="danger" icon="el-icon-document" @click="getlabelmanager">标签管理</el-button>
              <el-button size="mini" type="warning" icon="el-icon-plus" @click="shopaddlabel">店员新增标签</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="shopeditlabel">店员删除标签</el-button>
          </el-form-item>
	    </el-form>

      <el-tag type="danger" size="small" style="margin-top:10px">温馨提示：此处统计的为在商城上有下单记录的店员，而非宠老板的所有店员</el-tag>
	  
	    <!-- 店员数据统计 -->
      <div class="backborder2" style="margin-top:10px">
          <el-table :data="lists" v-loading="loading">
              <el-table-column label="店员名称" prop="truename" align="left" />
              <el-table-column label="手机号码" prop="phone" width="150" align="center" /> 
              <el-table-column label="所属店铺" prop="shopname" width="150" align="center" />
              <el-table-column label="店铺地址" prop="shocity" width="120" align="center" /> 
              <el-table-column label="实付金额小计" prop="reals" width="120" align="center" /> 
              <el-table-column label="下单总数量" prop="ordernums" width="120" align="center" /> 
              <el-table-column label="最后一次下单时间" prop="paytime" width="170" align="center" />   
              <el-table-column label="操作" align="center" width="150">
                <template slot-scope="scope">
                  <el-button type="warning" size="small" icon="el-icon-document" circle @click="editCurrent(scope.row)"></el-button>
                </template>
              </el-table-column>
          </el-table>
          <div class="block">
              <!--分页begin-->
              <el-pagination
                  @size-change="pageSizeChange"
                  @current-change="pageCurrentChange"
                  :current-page="query.p"
                  :page-sizes="[10, 20, 50]"
                  :page-size="query.rollpage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total_rows">
              </el-pagination>
              <!--分页end-->
          </div>
      </div>

      <!-- 标签管理 -->
      <el-dialog title="标签管理" :visible.sync="labelmanagerDialog" width="35%" top="10vh">
          <el-button type="danger" size="mini" icon="el-icon-plus" circle @click="addlabel" style="float:right;margin-right:20px"></el-button>
        <el-table :data="allabellists" v-loading="labelloading" style="margin-top:10px">
              <el-table-column label="id" prop="id" align="center" />
          <el-table-column label="标签名称" prop="name" align="left" /> 
          <el-table-column label="绑定店铺数" prop="number" align="center" />  
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
              <el-button type="warning" size="mini" icon="el-icon-edit" circle @click="editlabel(scope.row)"></el-button>
                  <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="dellabel(scope.row)"></el-button>
                </template>
              </el-table-column>
          </el-table>
      </el-dialog>

	  <!-- 新增标签 -->
	  <el-dialog title="新增 / 编辑标签" :visible.sync="addlabelDialog" width="25%" top="10vh">
		  <el-form :inline="true" class="demo-form-inline" size="mini">
	  	  	  <el-input placeholder="请输入标签名称" type="text" clearable v-model="labelquery.name" size="small"/>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addlabelDialog = false">取 消</el-button>
			  <el-button type="danger" size="small" @click="savelabels">保 存</el-button>
          </div>
	  </el-dialog>

	  <!-- 店员新增标签 -->
	  <el-dialog title="新增店员绑定标签" :visible.sync="shopaddlabelDialog" width="60%" top="10vh" :before-close="closeshopaddwindow">
		  <el-form :inline="true" class="demo-form-inline" size="mini">
			  <el-form-item style="width:20%">
				<el-select v-model="shoplabelquery.labelid" remote  filterable placeholder="请选择店员标签" @change="changeaddlabel">
					<el-option v-for="(item,index) in labellists" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select> 
			  </el-form-item>
			  <el-form-item>
				  <el-input  placeholder="店员名称" type="text" clearable v-model="shoplabelquery.key" @change="addischange=true"/>
			  </el-form-item>
			  <el-form-item>
			  	<el-button type="primary" size="mini" icon="el-icon-search" circle @click="getshopaddlabellists"></el-button>
			  </el-form-item>
	  	  </el-form>

        <div class="shop-add-temp">
          <el-tag type="danger" size="small" closable class="mall-select-label" v-for="(item,index) in shoptemplists" :key="index" @close="deladdshops(index)">{{item.name}}</el-tag>
        </div>
		    <el-table :data="addlabelshops" v-loading="shopaddlabelloading" ref="addmultipleTable" @select="selectsingle" @row-click="selectrow" @select-all="selectall">
		  	    <el-table-column type="selection" width="55" />
	          <el-table-column label="店员名称" prop="truename" align="left" />
            <el-table-column label="手机号码" prop="phone" width="200" align="center" />
            <el-table-column label="店铺名称" prop="shopname" width="200" align="center" /> 
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="addlabelpageSizeChange"
	              @current-change="addlabelpageCurrentChange"
	              :current-page="shoplabelquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="shoplabelquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="add_shop_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>	

		    <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="shopaddlabelDialog = false">取 消</el-button>
			      <el-button type="danger" size="small" @click="saveaddlabels">保 存</el-button>
        </div>
	    </el-dialog>

	    <!-- 店员解绑标签 -->
	    <el-dialog title="解除店铺绑定标签" :visible.sync="shopeditlabelDialog" width="60%" top="10vh" :before-close="closeshopeditwindow">
		    <el-form :inline="true" class="demo-form-inline" size="mini">
          <el-form-item style="width:20%">
            <el-select v-model="shopeditlabelquery.labelid" remote  filterable placeholder="请选择店员标签" @change="changeeditlabel">
              <el-option v-for="(item,index) in labellists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select> 
          </el-form-item>
          <el-form-item>
            <el-input  placeholder="店铺名称" type="text" clearable v-model="shopeditlabelquery.key" @change="editischange=true"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" circle @click="getshopeditlabellists"></el-button>
          </el-form-item>
	  	  </el-form>

        <div class="shop-add-temp">
          <el-tag type="danger" size="small" closable class="mall-select-label" v-for="(item,index) in shopedittemplists" :key="index" @close="deleditshops(index)">{{item.name}}</el-tag>
        </div>
		  <el-table :data="editlabelshops" v-loading="shopeditlabelloading" ref="editmultipleTable" @select="selecteditsingle" @row-click="selecteditrow" @select-all="selecteditall">
		  	  <el-table-column type="selection" width="55" />
	          <el-table-column label="店员名称" prop="truename" align="left" />
            <el-table-column label="手机号码" prop="phone" width="200" align="center" />
            <el-table-column label="店铺名称" prop="shopname" width="200" align="center" /> 
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	              @size-change="editlabelpageSizeChange"
	              @current-change="eidtlabelpageCurrentChange"
	              :current-page="shopeditlabelquery.p"
	              :page-sizes="[10, 20, 50]"
	              :page-size="shopeditlabelquery.rollpage"
	              layout="total, sizes, prev, pager, next, jumper"
	              :total="edit_shop_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>	

		  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="shopeditlabelDialog = false">取 消</el-button>
			  <el-button type="danger" size="small" @click="saveeditlabels">保 存</el-button>
          </div>
	  </el-dialog>

  </div>
  </transition>  
</template>

<script>

export default {
 
  data () {
    return {
        url:this.GLOBAL.domain+"Shop/index",
        transitionshow:true,
        actionauth:'', //功能权限
        ischange:false,
        query: {
          act:'usersaleslists',
          token:this.$cookies.get('token'),
          date:[],
          sprice:'',
          eprice:'',
          snums:'',
          enums:'',
          provinceid:'',
          cityid:'',
          labelid:'',
          keytype:1,
          key:'',
          sorttype:1,
          sort:1,
          p:1,
          rollpage:10
        },
        loading:false,
        lists:[],
		    total_rows:0,
        keylists:[
          {id:1,name:'店员名称'},
          {id:2,name:'店员手机'},
          {id:3,name:'店铺名称'}
        ],
        provincelists:[],
        citylists:[],
        labellists:[],
        sorttype:[
          {id:1,name:'按实付金额'},
          {id:2,name:'按下单数量'},
        ],
        sortlists:[
          {id:1,name:'降序'},
          {id:2,name:'升序'}
        ],

        allabellists:[],
        labelmanagerDialog:false,
        labelloading:false,

        labelquery: {
          act:'adduserlabel',
          token:this.$cookies.get('token'),
          name:''
        },
        addlabelDialog:false,

        shopaddlabelDialog:false,
        shopaddlabelloading:false,
        addlabelshops:[],
        shoptemplists:[],
        addischange:false,
        shoplabelquery: {
          act:'getadduser',
          token:this.$cookies.get('token'),
          oldlabelid:'',
          labelid:'',
          key:'',
          p:1,
          rollpage:10
        },
        add_shop_total_rows:0,

        shopeditlabelDialog:false,
        shopeditlabelloading:false,
        shopedittemplists:[],
        editlabelshops:[],
        edit_shop_total_rows:0,
        editischange:false,
        shopeditlabelquery: {
          act:'geteditusers',
          token:this.$cookies.get('token'),
          oldlabelid:'',
          labelid:'',
          key:'',
          p:1,
          rollpage:10
        },

    }
  },
    
  mounted(){  
      this.getactionauth();
      this.getList();
      this.getprovincelists(); //获取省份信息列表
      this.getlabellists();
  },
  
  methods:{
    
    //获取功能权限
    getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 获取省份信息列表 **/
    getprovincelists() {
        var resource = this.$resource(this.GLOBAL.domain+"Shippingarea/index");
        resource.query({act:'getcitylists',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else {
                this.provincelists=JSON.parse(Base64.decode(res.data.Data));
                var _this=this;
                this.provincelists.forEach(function(e,i) {
                  _this.provincelists[i].id=Number(e.id);
                });	  
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });  	  
    },

    /** 切换省份重新刷新城市数据 **/
    changecity(id) {
          this.query.cityid='';
          this.ischange=true;
          if(id=='') {this.citylists=[];return false;}
          var resource = this.$resource(this.GLOBAL.domain+"Shippingarea/index");
          resource.query({act:'getcitylists',pid:id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else {
                  this.citylists=JSON.parse(Base64.decode(res.data.Data));
                  var _this=this;
                  this.citylists.forEach(function(e,i) {
                    _this.citylists[i].id=Number(e.id);
                  });	  
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });  
    },

    //获取店铺标签信息
    getlabellists() {
      var resource = this.$resource(this.url);
          resource.query({act:'getuserlabellists',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.labellists = JSON.parse(Base64.decode(res.data.Data));
            }
          }).catch((res) => {
              
          });
    },


    /** 获取店员销售统计数据 **/
    getList() {
        if(this.ischange) {
          this.query.p=1;
          this.query.rollpage=10;
        }
		    this.loading=true;
		    var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				        this.loading=false;
	          }else{
				        this.lists=[];
	              this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.total_rows=parseInt(res.data.count);
                this.loading=false;
                if(this.ischange) this.ischange=false;
	          }
        }).catch((res) => {
            this.loading=false;
        });
	  },

	  pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    

    /** 获取店铺标签数据 **/
    getlabelmanager() {
      this.labelmanagerDialog=true;
      this.labelloading=true;
      this.allabellists=[];
      var resource = this.$resource(this.url);
          resource.query({act:'getalluserlabels',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.labelloading=false;
            }else{
                this.allabellists = JSON.parse(Base64.decode(res.data.Data));
                this.labelloading=false;
            }
          }).catch((res) => {
              this.labelloading=false;
          });
    },

    /** 删除标签 **/
    dellabel(item) {
          this.$confirm('删除该标签会解绑该标签下所有的店员，是否继续?', '提示', { type: 'warning' }).then(() => {
              var resource = this.$resource(this.url);
              resource.save({ act:'deluserlabel',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.getlabelmanager();
                      this.getlabellists();
                  }
              }).catch((res) => {
                
              });
          }).catch(() => {
            
          });
    },


    /** 新增标签 **/
    addlabel() {
      this.labelquery.id='';
      this.labelquery.name='';
      this.labelquery.act="adduserlabel";
      this.addlabelDialog=true;
    },

    /** 编辑标签 **/
    editlabel(item) {
      this.labelquery.id=item.id;
      this.labelquery.name=item.name;
      this.labelquery.act="edituserlabel";
      this.addlabelDialog=true;
    },

    /** 保存标签 **/
    savelabels() {
          var resource = this.$resource(this.url);
          resource.save(this.labelquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.addlabelDialog=false;
                  this.getlabelmanager();
                  this.getlabellists();
              }
          }).catch((res) => {
                
          });
    },


    //店铺绑定标签
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /** 店铺绑定新增标签 **/
    shopaddlabel() {
      this.shopaddlabelDialog=true;
      this.shoptemplists=[];
      this.shoplabelquery.key='';
      this.shoplabelquery.oldlabelid=this.labellists[0].id;
      this.shoplabelquery.labelid=this.labellists[0].id;
      this.shoplabelquery.p=1;
      this.shoplabelquery.rollpage=10;
      this.getshopaddlabellists();
    },

    /** 错误关闭当前页面 **/
    closeshopaddwindow() {
          this.$confirm('是否关闭当前窗口离开当前页面，是否继续?', '提示', { type: 'warning' }).then(() => {
              this.shopaddlabelDialog=false;
          }).catch(() => {
            
          });
    },

    /** 获取添加标签的店铺 **/
    getshopaddlabellists() {
      if(this.addischange) {
        this.shoplabelquery.p=1;
        this.shoplabelquery.rollpage=10;
      }
      this.shopaddlabelloading=true;
      var resource = this.$resource(this.url);
          resource.save(this.shoplabelquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.shopaddlabelloading=false;
            }else{
                this.addlabelshops=[];
                this.addlabelshops = JSON.parse(Base64.decode(res.data.Data));
                this.add_shop_total_rows=parseInt(res.data.count);
                this.shopaddlabelloading=false;
                if(this.addischange) this.addischange=false;

                var _this=this;
                var ids=[];
                this.shoptemplists.forEach(function(item,index) {ids.push(item.id)});
                setTimeout(function() {
                    _this.addlabelshops.forEach(function(item,index) {
                        ids.indexOf(item.id) >=0 ? _this.$refs.addmultipleTable.toggleRowSelection(_this.addlabelshops[index]) : '';
                    });
                },200);
            }
          }).catch((res) => {
              this.shopaddlabelloading=false;
          });
    },

	  addlabelpageSizeChange(val) {
        this.shoplabelquery.rollpage = val;
        this.getshopaddlabellists();
    },
    addlabelpageCurrentChange(val) {
        this.shoplabelquery.p = val;
        this.getshopaddlabellists();
    },


    /** 切换新增标签 **/
    changeaddlabel() {
      this.$confirm('切换标签会删除已选中的店铺信息，是否继续?', '提示', { type: 'warning' }).then(() => {
          this.shoplabelquery.oldlabelid=this.shoplabelquery.labelid;
          this.addischange=true;
          this.shoptemplists=[];
          this.shoplabelquery.key='';
          this.shoplabelquery.p=1;
          this.shoplabelquery.rollpage=10;
          this.getshopaddlabellists();
      }).catch(() => {
          this.shoplabelquery.labelid=this.shoplabelquery.oldlabelid;
      });
    },

    /** 取消已选中的店铺信息 **/
    deladdshops(index) {
      var number=-1;
      var shopid=this.shoptemplists[index].id;
      this.$delete(this.shoptemplists,index);
      this.addlabelshops.forEach(function(t,i) {if(t.id==shopid) number=i;});
      if(number >=0) this.$refs.addmultipleTable.toggleRowSelection(this.addlabelshops[number]);
    },

    /** 单个商品点击选择 **/
    selectsingle(obj,item) {
      var ids=[];
      var number=0;
      this.shoptemplists.forEach(function(item,i) {ids.push(item.id);});
      number=ids.indexOf(item.id);
      number >= 0 ? this.$delete(this.shoptemplists,number) : this.shoptemplists.push({id:item.id,name:item.truename});
    },

    /** 单行点击 **/
    selectrow(item,number) {
      var ids=[];
      var number=0;
      this.shoptemplists.forEach(function(item,i) {ids.push(item.id);});
      number=ids.indexOf(item.id);
      number >= 0 ? this.$delete(this.shoptemplists,number) : this.shoptemplists.push({id:item.id,name:item.truename});

      number=-1;
      this.addlabelshops.forEach(function(t,i) {if(t.id==item.id) number=i; });
      if(number >=0) this.$refs.addmultipleTable.toggleRowSelection(this.addlabelshops[number]);
    },

	  /** 全选/全不选店铺 **/
    selectall(item) {
		let _this=this;
		if(item.length > 0) { //全选
			this.addlabelshops.forEach(function(t,i) {
				var ids=[];
				_this.shoptemplists.forEach(function(tt,ii) {ids.push(tt.id)});
				ids.indexOf(t.id)==-1 ? _this.shoptemplists.push({id:t.id,name:t.truename}) : '';
			});
		}else { //全不选
 			  this.addlabelshops.forEach(function(t,i) {
          var ids=[];
          _this.shoptemplists.forEach(function(tt,ii) {ids.push(tt.id)});
          var number=ids.indexOf(t.id);
          if(number >=0) _this.$delete(_this.shoptemplists,number);
			  });
		} 
	},

	/** 保存标签绑定的店铺 **/
	saveaddlabels() {
		var ids=[];
		this.shoptemplists.forEach(function(item,index) {ids.push(item.id)});
		var resource = this.$resource(this.url);
        resource.save({ act:'addlabeltouser',ids:ids,labelid:this.shoplabelquery.labelid,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
				        this.shopaddlabelDialog=false;
                this.getList();
            }
        }).catch((res) => {
            	
        });
	},


	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



	//店铺解绑标签
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/** 店铺解绑标签 **/
	shopeditlabel() {
		this.shopeditlabelDialog=true;
		this.shopedittemplists=[];
		this.shopeditlabelquery.key='';
		this.shopeditlabelquery.oldlabelid=this.labellists[0].id;
		this.shopeditlabelquery.labelid=this.labellists[0].id;
		this.shopeditlabelquery.p=1;
		this.shopeditlabelquery.rollpage=10;
		this.getshopeditlabellists();
	},

	/** 错误关闭当前页面 **/
	closeshopeditwindow() {
		  this.$confirm('是否关闭当前窗口离开当前页面，是否继续?', '提示', { type: 'warning' }).then(() => {
          this.shopeditlabelDialog=false;
      }).catch(() => {
        	
      });
	},

	/** 获取添加标签的店铺 **/
	getshopeditlabellists() {
		if(this.editischange) {
			this.shopeditlabelquery.p=1;
			this.shopeditlabelquery.rollpage=10;
		}
		this.shopeditlabelloading=true;
		var resource = this.$resource(this.url);
        resource.save(this.shopeditlabelquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
				      this.shopeditlabelloading=false;
	        }else{
				      this.editlabelshops=[];
	            this.editlabelshops = JSON.parse(Base64.decode(res.data.Data));
              this.edit_shop_total_rows=parseInt(res.data.count);
              this.shopeditlabelloading=false;
              if(this.editischange) this.editischange=false;

              var _this=this;
              var ids=[];
              this.shopedittemplists.forEach(function(item,index) {ids.push(item.id)});
              setTimeout(function() {
                  _this.editlabelshops.forEach(function(item,index) {
                      ids.indexOf(item.id) >=0 ? _this.$refs.editmultipleTable.toggleRowSelection(_this.editlabelshops[index]) : '';
                  });
              },200);
	        }
        }).catch((res) => {
            this.shopeditlabelloading=false;
        });

	},

	editlabelpageSizeChange(val) {
        this.shopeditlabelquery.rollpage = val;
        this.getshopeditlabellists();
    },
    editlabelpageCurrentChange(val) {
        this.shopeditlabelquery.p = val;
        this.getshopeditlabellists();
    },


	/** 切换新增标签 **/
	changeeditlabel() {
		    this.$confirm('切换标签会删除已选中的店铺信息，是否继续?', '提示', { type: 'warning' }).then(() => {
            this.shopeditlabelquery.oldlabelid=this.shopeditlabelquery.labelid;
            this.editischange=true;
            this.shopedittemplists=[];
            this.shopeditlabelquery.key='';
            this.shopeditlabelquery.p=1;
            this.shopeditlabelquery.rollpage=10;
            this.getshopeditlabellists();
        }).catch(() => {
        	this.shopeditlabelquery.labelid=this.shopeditlabelquery.oldlabelid;
        });
	},

	/** 取消已选中的店铺信息 **/
	deleditshops(index) {
		var number=-1;
		var shopid=this.shopedittemplists[index].id;
		this.$delete(this.shopedittemplists,index);
		this.editlabelshops.forEach(function(t,i) {if(t.id==shopid) number=i;});
		if(number >=0) this.$refs.editmultipleTable.toggleRowSelection(this.editlabelshops[number]);
	},

	/** 单个商品点击选择 **/
	selecteditsingle(obj,item) {
		var ids=[];
		var number=0;
		this.shopedittemplists.forEach(function(item,i) {ids.push(item.id);});
		number=ids.indexOf(item.id);
		number >= 0 ? this.$delete(this.shopedittemplists,number) : this.shopedittemplists.push({id:item.id,name:item.truename});
	},

	/** 单行点击 **/
	selecteditrow(item,number) {
		var ids=[];
		var number=0;
		this.shopedittemplists.forEach(function(item,i) {ids.push(item.id);});
		number=ids.indexOf(item.id);
		number >= 0 ? this.$delete(this.shopedittemplists,number) : this.shopedittemplists.push({id:item.id,name:item.truename});

		number=-1;
		this.editlabelshops.forEach(function(t,i) {if(t.id==item.id) number=i; });
		if(number >=0) this.$refs.editmultipleTable.toggleRowSelection(this.editlabelshops[number]);
	},

	/** 全选/全不选店铺 **/
  selecteditall(item) {
		let _this=this;
		if(item.length > 0) { //全选
			this.editlabelshops.forEach(function(t,i) {
				  var ids=[];
				  _this.shopedittemplists.forEach(function(tt,ii) {ids.push(tt.id)});
				  ids.indexOf(t.id)==-1 ? _this.shopedittemplists.push({id:t.id,name:t.truename}) : '';
			});
		}else { //全不选
 			  this.editlabelshops.forEach(function(t,i) {
            var ids=[];
            _this.shopedittemplists.forEach(function(tt,ii) {ids.push(tt.id)});
            var number=ids.indexOf(t.id);
            if(number >=0) _this.$delete(_this.shopedittemplists,number);
			  });
		} 
	},

	/** 保存标签绑定的店铺 **/
	saveeditlabels() {
        var ids=[];
        this.shopedittemplists.forEach(function(item,index) {ids.push(item.id)});
        var resource = this.$resource(this.url);
        resource.save({ act:'editlabeltouser',ids:ids,labelid:this.shopeditlabelquery.labelid,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
				        this.shopeditlabelDialog=false;
                this.getList();
            }
        }).catch((res) => {
            	
        });
	},

	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


	/** 店铺销售信息详情 **/
	editCurrent(item) {
		this.$emit('listenchild',{name:item.truename+'销售统计',url:'Mallsalesuserdetail',data:item});
	},



    

   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.agent-area .el-form-item__content {width:65%}
.input1 .el-form-item__content {width:77%}
.shop-add-temp {float:left;width:96%;padding:10px 2% 20px 2%;border-radius:5px;background:#dddddd;}
.mall-select-label {float:left;font-size:12px;margin:10px 10px 0 0;background:red;color:#fff}
.mall-select-label .el-tag__close {color:#fff}
</style>


// WEBPACK FOOTER //
// src/components/mall/mallsalesuser.vue